<template>
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <blue-title class="style">结算规则</blue-title>
      <SettlementRule
        :count.sync="count"
        :subjectTypeList="subjectTypeList"
        :specialList="specialList"
        :ruleData="ruleData"
        @handleMediaId="handleMediaId"
        @changeSpecial="changeSpecial"
        @confirm="handleValiditySettlementRule"
      ></SettlementRule>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="info" @click="count++">保存草稿</el-button>
        <el-button type="primary" @click="count++">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SettlementRule from '../../components/settlementRule/settlementRule';
import { subjectType, settlementRulesIdQuery } from '../../../../api/module/merchants';
import { saveEditDraft, draftEcho, mediaId } from '../../../../api/module/merchants';

export default {
  components: {
    SettlementRule,
  },
  props: {},
  data() {
    return {
      subjectTypeList: [],
      specialList: [],
      count: 0, // 是否开始验证
      SettlementRuleInfo: {
        settlementId: '',
        qualifications: '',
        qualificationsCopy: [],
        activitiesId: '',
        activitiesRate: '',
        activitiesAdditions: '',
        specialType: '',
        qualificationType: '',
      },
      SettlementRulePass: false,
      ruleData: {},
      qualificationsMedia: '',
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    },
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
  },
  watch: {},
  created() {
    this.subjectType();
    if (this.type == 'edit') {
      this.draftEcho();
    }
  },
  methods: {
    changeSpecial(val) {
      this.settlementRulesIdQuery(val);
    },
    async subjectType() {
      let bodyType = '';
      if (this.id == 0) {
        bodyType = '个体户';
      } else if (this.id == 1) {
        bodyType = '企业';
      } else if (this.id == 2) {
        bodyType = '党政、机关及事业单位';
      } else if (this.id == 3) {
        bodyType = '其他组织';
      }
      const result = await subjectType({
        subjectType: bodyType,
      });
      console.log('列表', result);
      this.subjectTypeList = result;
    },
    handleValiditySettlementRule({ flag, ruleForm }) {
      this.SettlementRuleInfo = { ...ruleForm };
      this.SettlementRulePass = flag;
      this.handleSave();
    },
    handleSave() {
      const { SettlementRulePass } = this;
      if (SettlementRulePass) {
        console.log('成功');
        const obj = this.formatSubmitData();
        console.log('处理后的数据===', obj);
        this.saveEditDraft(obj);
      } else {
        console.log('失败');
      }
    },
    formatSubmitData() {
      let obj = {};
      // const { id } = this.$route.query;
      const { SettlementRuleInfo, uuid, merchantId, qualificationsMedia } = this;
      obj = {
        settlementRulesVO: {
          activitiesAdditions: SettlementRuleInfo.activitiesAdditions,
          activitiesId: SettlementRuleInfo.activitiesId,
          activitiesRate: SettlementRuleInfo.activitiesRate,
          qualificationsMedia,
          qualificationType: SettlementRuleInfo.qualifications.split(',')[1],
          qualifications: SettlementRuleInfo.qualifications.split(',')[0],
          qualificationsCopy: SettlementRuleInfo.qualificationsCopy,
          settlementId: SettlementRuleInfo.settlementId,
          uuid: '',
        },
        uuid,
        merchantId,
        type: 'settlementRules',
        listVO: {
          status: 0,
          subjectType: this.subjectName,
          merchantType: this.facilitatorName,
        },
      };
      return obj;
    },
    async saveEditDraft(obj) {
      console.log(obj);
      try {
        const result = await saveEditDraft({ ...obj });
        console.log('保存结果', result);
        this.$message({
          message: '保存成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.replace({
              path: '/merchants/addMerchants',
              query: {
                id: this.id,
                subjectName: this.subjectName,
                facilitatorName: this.facilitatorName,
                type: 'edit',
                uuid: result,
                merchantId: this.merchantId,
              },
            });
          },
        });
      } catch (err) {
        this.$message({
          message: '保存失败',
          type: 'warring',
          duration: 1500,
        });
      }
    },
    back() {
      this.$router.replace({
        path: '/merchants/addMerchants',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    handleMediaId(url, fileName) {
      this.mediaId(url, fileName);
    },
    async mediaId(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.qualificationsMedia = result.mediaId;
      console.log('qualificationsMedia', result.mediaId);
    },
    async draftEcho() {
      const result = await draftEcho({
        uuid: this.uuid,
      });
      this.settlementRulesIdQuery(result.settlementRulesVO.settlementId);
      this.ruleData = result;
      console.log('回显所填信息', result);
    },
    async settlementRulesIdQuery(val) {
      const result = await settlementRulesIdQuery({
        settlementRulesId: val,
      });
      console.log('列表', result);
      this.specialList = result;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  padding-top: 20px;
  .style {
    margin-bottom: 9px;
  }
  .btn {
    box-sizing: border-box;
    padding-left: 31px;
    margin-top: 57px;
    padding-bottom: 100px;
  }
}
</style>
